import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import merge from 'lodash/merge';

export interface Menu {
  name: string;
  icon?: string;
  url: string;
  permission: { permission: string[] };
  children?: {
    name: string;
    url: string;
    permission: { permission: string[] };
  }[];
}

export const setMenu = createAction('[Menu] Set Menu Info', props<{ menu: Menu[] }>());
export const mergeMenu = createAction('[Menu] Merge Menu Info', props<{ menu: Menu[] }>());
export const resetMenu = createAction('[Menu] Reset Empty Menu');

export function menuReducer(pState: Menu | undefined, action: Action) {
  return createReducer(
    {},
    on(setMenu, (state, menu) => menu),
    on(mergeMenu, (state, menu) => merge({}, state, menu)),
    on(resetMenu, state => null)
  )(pState, action);
}
